module.exports = __webpack_public_path__ + "static/media/BarlowCondensed.69218003.woff2";